import { defaultGrid } from "@helpers/datagrid";
import { initialState } from "@reducers/organisationDirectoryReducer";

export const emptyTransactionsSection =
  (clearFilters = true) =>
  async (dispatch) => {
    dispatch({ type: "FETCH_TRANSACTIONS", payload: defaultGrid });
    if (clearFilters)
      dispatch({
        type: "FETCH_TRANSACTIONS_FILTERS",
        payload: { ...initialState },
      });
  };

export const setTransactionsKiosk = (payload) => async (dispatch) => {
  dispatch({ type: "TRANSACTIONS_KIOSK", payload });
};

export const setTransactionsLiability = (payload) => async (dispatch) => {
  dispatch({ type: "TRANSACTIONS_LIABILITY", payload });
};

export const setTransactionsTickets = (payload) => async (dispatch) => {
  dispatch({ type: "TRANSACTIONS_TICKETS", payload });
};

export const setTransactionsView = (payload) => async (dispatch) => {
  dispatch({ type: "TRANSACTIONS_VIEW", payload });
};
